import { LogLevel } from '@nts/std/src/lib/utility';

export const environment = {
  production: true,
  baseAppUrl: 'https://ntsbusinesscloud.ntsinformatica.it',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'BusinessCloud - DEV',
  appSubTitle: 'Business',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: false
};
